import React from 'react';
import { Provider } from 'models';
import ProviderSummaryDetailRow from './ProviderSummaryDetailRow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarker, faMobileScreenButton } from '@fortawesome/free-solid-svg-icons';
import CenterCertifiedBanner from './CenterCertifiedBanner';
import PendingCenterCertifiedBanner from './PendingCenterCertifiedBanner';
import { Star } from '@mui/icons-material';
import { useProviderProfileContext } from './ProviderProfileContext';
import { getPrioritizedCredentials } from './helpers/Helpers';
import { TextButton } from 'library';
import { useHistory } from 'react-router';

export default function BusinessProviderSummary({
    provider,
    distanceText,
    mobile,
}: {
    provider: Provider;
    distanceText: string;
    mobile: boolean;
}) {
    const history = useHistory();
    const { providerQualifications, childcareCenterQualifications } = useProviderProfileContext();
    const prioritizedCredentials = getPrioritizedCredentials(providerQualifications, childcareCenterQualifications);
    const details = [
        {
            detail: prioritizedCredentials ? 'Notable Credentials' : '',
            icon: <Star />,
            subDetail: prioritizedCredentials,
            bold: true,
        },
        {
            detail: provider.user.last_active,
            icon: <FontAwesomeIcon icon={faMobileScreenButton} style={{ fontSize: 14 }} />,
            italic: true,
        },
        {
            detail: !!provider.user.address
                ? `${provider.user.address[0].city.trim()}, ${provider.user.address[0].state}`
                : '',
            subDetail: distanceText,
            icon: <FontAwesomeIcon icon={faMapMarker} style={{ fontSize: 12 }} />,
        },
    ];

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: mobile ? '75%' : '100%',
                marginLeft: mobile ? 12 : 0,
                marginTop: mobile ? 0 : 20,
            }}
        >
            {provider.hasBCIFBICheck || provider.ready_to_work ? (
                <CenterCertifiedBanner />
            ) : (
                <PendingCenterCertifiedBanner />
            )}
            <div style={{ width: '70%' }}>
                {details.map((detail) =>
                    !!detail.detail ? <ProviderSummaryDetailRow key={detail.detail} {...detail} /> : null,
                )}
            </div>
            {provider.is_staff ? (
                <div style={{ marginTop: '4%' }}>
                    <TextButton onClick={() => history.push(`/providers/review/${provider.user.id}`)}>
                        Add a Review
                    </TextButton>
                </div>
            ) : null}
        </div>
    );
}
